// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__pXvvb","cardContent":"Card_cardContent__N7v5t","cardTitle":"Card_cardTitle__qRzJX","cardWrapper":"Card_cardWrapper__tpNTZ","category":"Card_category__3mS6O"};